import { useEffect } from "react";
import RecentActivity from "./recentActivity/RecentActivity";
import Stats from "./Stats";
import ShortcutMenu from "./ShortcutMenu";
import { useWriterHomeQuery } from "./homeApiSlice";

interface StudentHomeProps {
	setAlerts: (alerts: Record<number, string> | undefined) => void;
}

export default function StudentHome(props: StudentHomeProps) {
	const result = useWriterHomeQuery();
	const data = result.data;

	useEffect(() => {
		props.setAlerts(data?.alerts);
	}, [data]);

	return (
		<div>
			<Stats
				label="Your Usage"
				courseCreateDate={data?.courseCreateDate}
				loading={result.isLoading}
				stats={data?.allStats ?? []}
			/>
			<div className="mt-4 flex py-2 flex-col sm:flex-row">
				<RecentActivity
					label="Recent Activity"
					loading={result.isLoading}
					studentData={data}
				/>
				<div className="px-4 lg:px-8 w-full sm:w-1/3 md:w-1/4">
					<ShortcutMenu />
				</div>
			</div>
		</div>
	);
}
